import {
  GET_USER_AGREEMENTS_STATUS,
  STORE_USER_AGREEMENTS_STATUS,
  STORE_OVERALL_AGREEMENTS,
  STORE_TOP_AGREEMENT_IS_OPEN,
} from "actions"

export const initialState = {
  userAgreementsStatus: null,
  overallAgreements: null,
  topAgreementsDialogIsOpen: false,
}

export const UserAgreementsStatus = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_AGREEMENTS_STATUS:
      return { ...state, ...action.payload }
    case STORE_USER_AGREEMENTS_STATUS:
      return { ...state, ...action.payload }
    case STORE_OVERALL_AGREEMENTS:
      return { ...state, ...action.payload }
    case STORE_TOP_AGREEMENT_IS_OPEN:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export default UserAgreementsStatus
